import React from 'react';

export default require(`../tenants/${process.env.REACT_APP_CLIENT}/routes/index`).default as React.FC;